export enum DtoMessageEnum {
  REQUIRED_FIELD = 'Поле обязательно для заполнения',

  EMPTY_ARRAY = 'Список не может быть пустым',

  EMPTY_STRING = 'Поле не может быть пустым',

  MISSED_USER_FIRST_NAME = 'Не указано имя пользователя',

  MISSED_USER_LAST_NAME = 'Не указана фамилия пользователя',

  MISSED_USER_NAME = 'Не указано имя пользователя',

  INCORRECT_EMAIL = 'Неверный адрес email',

  INCORRECT_JOB = 'Неверная должность',

  INCORRECT_PHONE = 'Неверный телефон',

  MINIMUM_ROLE = 'Для пользователя необходимо задать хотя бы $constraint1 роль(и)',

  INCORRECT_FORMAT = 'Неверный формат реквизита',

  MODULE_NAME_TOO_SHORT = 'Имя модуля должно содержать хотя-бы $constraint1 символ(ов)',

  MODULE_NAME_TOO_LONG = 'Имя модуля должно содержать не более $constraint1 символов',

  NOT_INTEGER = 'Значение должно быть целым числом',

  NOT_STRING = 'Значение должно быть строкой',

  NOT_VALID_TYPE = 'Некорректный тип значения',

  NOT_DATE = 'Некорректный формат даты',

  NOT_ZERO_OR_POSITIVE = 'Значение должно быть больше, либо равно нулю',

  NOT_POSITIVE = 'Значение может быть только положительным числом',

  NOT_POSITIVE_INTEGER = 'Значение может быть только положительным целым числом',

  NOT_BOOLEAN = 'Значение должно быть булевым',

  NOT_ENTITY_LIKE = 'Значение должно быть объектом и содержать хотя-бы идентификатор',

  NOT_UNIQUE_ARRAY = 'Список должен содержать уникальные значения',

  INCORRECT_PLANNING_UNIT = 'Некорректно заполнены настройки планирования',

  STRING_TOO_SHORT = 'Значение должно содержать хотя-бы $constraint1 символ(ов)',

  STRING_TOO_LONG = 'Значение должно содержать не более $constraint1 символ(ов)',

  INVALID_HEX_COLOR = 'Значение должно быть цветом в формате RGB HEX',

  INVALID_SEM_VER = 'Значение должно быть версией в формате "SemVer" ("<мажорная>.<минорная>.<патч>")',

  INVALID_DAY_HOURS = 'Количество часов в сутках должны быть числом от 0 до 24',

  PAGINATION_LIMIT_TOO_SMALL = 'Список не может содержать меньше одного элемента',

  PAGINATION_LIMIT_TOO_BIG = 'Список может быть не более 500 элементов',

  PAGINATION_OFFSET_NEGATIVE = 'Нельзя пропустить отрицательное число элементов',

  INVALID_URL = 'Значение должно быть ссылкой',
}
